import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Image, Space, Upload } from "antd";

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const ImageUploader = ({ fileList, beforeUpload = true, handleChange, length = 1, setFileList, setRemovedImages, remove = true,
    disabled = false
}) => {

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const customRequest = (e) => {
        e.onSuccess();
    };

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleRemoveAll = async () => {
        // Track removed images with URLs before clearing
        const removedUrls = fileList.filter(file => file.url).map(file => file.url);

        if (removedUrls.length > 0) {
            setRemovedImages(prev => [...prev, ...removedUrls]);
        }

        setFileList([]); // Clear all files
    }

    return (
        <>
            {remove === false ? null : fileList.length > 0 && <div style={{ marginBottom: 10 }}>
                <Button type="primary" onClick={handleRemoveAll}>
                    Remove All
                </Button>
            </div>}
            <Space >
                {/* <ImgCrop > */}
                <Upload
                    name="image"
                    accept=".jpg,.jpeg,.png,.svg,.avif,.webp"
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                    fileList={fileList}
                    listType="picture-card"
                    customRequest={customRequest}
                    maxCount={length}
                    onPreview={handlePreview}
                    multiple
                    disabled={disabled}
                >
                    {fileList.length < length && (
                        <div>
                            <UploadOutlined />
                            <div style={{ marginTop: 8 }}>Upload</div>
                        </div>
                    )}
                </Upload>
                {/* </ImgCrop> */}
            </Space>

            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}

        </>
    );
};

export default ImageUploader;